export const DELIVERY_METHOD_KEYS = {
  AIR_CARGO: 'air-cargo',
  GROUND_TRANSPORT: 'ground-transport',
  FLIGHT_NANNY: 'flight-nanny',
  MEET_HALFWAY: 'meet-halfway'
};
